import QuizForm from './QuizFormWorkCycleEvaluation';
export default QuizForm;